import { Modal } from "@mantine/core";
import { imageBaseUrl } from "../../utilities/constants";

const PostBlockPreview = ({ opened, setOpend, block = {}, loading }) => {
  const close = () => setOpend(false);

  return (
    <Modal
      centered
      opened={opened}
      onClose={close}
      title='Blocks Preview'
      overlayProps={{ backgroundOpacity: 0.3 }}
      zIndex={"999"}
      size='full'
    >
      <div className='overflow-auto max-h-[90vh] bg-white p-2 rounded  w-[1000px] mx-auto text-[13px] text-[#333] font-[Arial,sans-serif]'>
        {loading ? (
          <p className='text-center py-8'>Loading...</p>
        ) : (
          <>
            {/* Blocks */}
            <div className='mt-6'>
              {block?.blocks?.map((b) => {
                const value = b?.value ?? "";
                const text = b?.text ?? "";
                const styles = b?.styles || {};

                if (b.type === "image") {
                  const src = value.startsWith("http")
                    ? value
                    : `${imageBaseUrl}/${value}`;
                  return (
                    <div key={b.id} className='text-center my-5'>
                      <img
                        src={src}
                        alt='Email visual'
                        style={{
                          maxWidth: "100%",
                          height: "auto",
                          ...styles,
                        }}
                      />
                    </div>
                  );
                }

                if (b.type === "hr") {
                  return (
                    <hr
                      key={b.id}
                      style={{
                        margin: styles.margin || "16px 0",
                        border: styles.border || "1px solid #ccc",
                        width: styles.width || "100%",
                      }}
                    />
                  );
                }

                if (b.type === "table") {
                  const tableData = b?.value?.data || [];
                  const rows = b?.value?.rows || tableData.length;
                  const cols = b?.value?.cols || tableData[0]?.length || 0;
                  const styles = b?.styles || {};

                  return (
                    <table
                      key={b.id}
                      className='border border-gray-400 w-full table-auto my-4'
                      style={{
                        borderCollapse: "collapse",
                        width: styles.width || "100%",
                        margin: styles.margin || "16px 0",
                        padding: styles.padding || "0",
                        fontSize: styles.fontSize || "10px",
                        color: styles.color || "#333",
                        backgroundColor:
                          styles.backgroundColor || "transparent",
                        textAlign: styles.textAlign || "left",
                      }}
                    >
                      <thead>
                        <tr>
                          {Array.from({ length: cols }).map((_, colIndex) => (
                            <th
                              key={colIndex}
                              className='border bg-gray-100 p-2 text-left font-bold text-sm'
                              style={{
                                fontSize: styles.fontSize,
                                color: styles.color,
                                backgroundColor: styles.headerBg || "#f3f4f6",
                                textAlign: styles.textAlign,
                              }}
                            >
                              {tableData?.[0]?.[colIndex] ||
                                `Header ${colIndex + 1}`}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tableData?.slice(1)?.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            {row?.map((cell, colIndex) => (
                              <td
                                key={colIndex}
                                className='border p-2 text-sm'
                                style={{
                                  fontSize: styles.fontSize,
                                  color: styles.color,
                                  backgroundColor: styles.backgroundColor,
                                  textAlign: styles.textAlign,
                                }}
                              >
                                {cell}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  );
                }

                if (b.type === "link") {
                  return (
                    <div key={b.id} style={{ margin: "10px 0" }}>
                      <a
                        href={value}
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{
                          display: styles.display || "inline-block",
                          fontFamily: styles.fontFamily || "Arial, sans-serif",
                          fontSize: styles.fontSize || "13px",
                          fontWeight: styles.fontWeight || "normal",
                          color: styles.color || "#0000EE",
                          textDecoration: styles.textDecoration || "underline",
                          backgroundColor:
                            styles.backgroundColor || "transparent",
                          border: styles.border || "none",
                          borderRadius: styles.borderRadius || "4px",
                          padding: styles.padding || "10px 20px",
                          margin: styles.margin || "0",
                          lineHeight: styles.lineHeight || "1.5",
                          textAlign: styles.textAlign || "center",
                          width: styles.width,
                          height: styles.height,
                        }}
                      >
                        {text || value}
                      </a>
                    </div>
                  );
                }

                if (b.type === "rich") {
                  return (
                    <div
                      key={b.id}
                      style={{
                        display: styles.display || "block",
                        fontFamily: styles.fontFamily || "Arial, sans-serif",
                        fontSize: styles.fontSize || "13px",
                        fontWeight: styles.fontWeight || "normal",
                        margin: "20px 0",
                        // color: styles.color || "#000",
                        // textDecoration: styles.textDecoration || "none",
                        // backgroundColor: styles.backgroundColor || "#fff",
                        // border: styles.border || "none",
                        // borderRadius: styles.borderRadius || "0px",
                        // padding: styles.padding || "0px",
                        // margin: styles.margin || "0px",
                        // lineHeight: styles.lineHeight || "1.5",
                        // textAlign: styles.textAlign || "left",
                      }}
                      dangerouslySetInnerHTML={{ __html: value }}
                    />
                  );
                }
                if (b.type === "p") {
                  return (
                    <div
                      key={b.id}
                      style={{
                        display: styles.display,
                        fontFamily: styles.fontFamily || "Arial, sans-serif",
                        fontSize: styles.fontSize || "13px",
                        fontWeight: styles.fontWeight || "normal",
                        color: styles.color || "#000",
                        textDecoration: styles.textDecoration || "none",
                        backgroundColor: styles.backgroundColor || "#fff",
                        border: styles.border || "none",
                        borderRadius: styles.borderRadius || "0px",
                        padding: styles.padding || "0px",
                        margin: styles.margin || "0px",
                        lineHeight: styles.lineHeight || "1.5",
                        textAlign: styles.textAlign || "left",
                      }}
                      dangerouslySetInnerHTML={{ __html: value }}
                    />
                  );
                }

                const Tag = b.type || "p";
                return (
                  <div key={b.id}>
                    <Tag
                      style={{
                        display: styles.display || "block",
                        fontFamily: styles.fontFamily || "Arial, sans-serif",
                        fontSize: styles.fontSize || "13px",
                        fontWeight: styles.fontWeight || "normal",
                        color: styles.color || "#000",
                        textDecoration: styles.textDecoration || "none",
                        backgroundColor: styles.backgroundColor || "#fff",
                        border: styles.border || "none",
                        borderRadius: styles.borderRadius || "0px",
                        padding: styles.padding || "0px",
                        margin: styles.margin || "0px",
                        lineHeight: styles.lineHeight || "1.5",
                        textAlign: styles.textAlign || "left",
                      }}
                      dangerouslySetInnerHTML={{ __html: value }}
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default PostBlockPreview;
